import React from 'react';
import {interpolateRgb} from 'd3-interpolate';

const HoverInfo = ({active_mode, hover_info, formatters, interpolators, browser_width}) => {
  const y_adjust = 50;

  let property_display;
  let background;
  if (active_mode === 'Price') {
    background = interpolators.money(hover_info.properties.price/2000000);
    property_display = <div
      className="py1"
      style={{
        border: 'solid 1px rgba(0,0,0,0.1)',
        background: background,
      }}
    >
        <div>
          {formatters.dollarShort(hover_info.properties.price)}
        </div>
      </div>
  } else {
    background = interpolators.chance(hover_info.properties.probability);
    property_display = <div
      className="py1"
      style={{
        background: background,
      }}
    >
        <div>
          {formatters.percentFormat(hover_info.properties.probability)}
        </div>
      </div>
  }

  let title = hover_info.properties.neighborhood;
  let title_class = 'mb1';
  if (title === undefined && hover_info.active_neighborhood) {
    title = 'Hex ' + hover_info.properties.hexid;
    title_class = '';
  }

  return (
    <div>
      {hover_info ? (
        <div id="HoverInfo"
          style={{
            left: browser_width < 801 ? (hover_info.point.x - 100) : (hover_info.point.x - 100 + 360),
            top: hover_info.point.y - y_adjust,
            lineHeight: 1
          }}
        >
          <div id="HoverInner" className="p1 border h5 center">
            <div
              className="truncate mb1"
            >
              {title}
            </div>
            {property_display}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default HoverInfo;


/** WEBPACK FOOTER **
 ** ./src/components/HoverInfo.js
 **/